import { Injectable, inject } from '@angular/core';
import { Actions, createEffect } from '@ngrx/effects';
import { filter, map } from 'rxjs/operators';
import * as ErrorActions from '../actions/error.actions';
import { RequestStatusAction } from '../actionstypes/request-status/request-status.actiontype';

@Injectable()
export class RequestStatusEffects {
  private readonly actions$ = inject(Actions);

  handleRequestStatusError$ = createEffect(() =>
    this.actions$.pipe(
      // More robustly check if the action is an instance of RequestStatusAction
      // and has an error property. This is safer than relying on ofType with multiple action types.
      filter((action: any): action is RequestStatusAction => action.constructor === RequestStatusAction && action.error != null),
      map((action: RequestStatusAction) => ErrorActions.displayGlobalError({ error: action.error! })),
    ),
  );
}
